import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { PinnedResult } from './pinned-result'
import { SearchResult } from '@Generated/back-office-client/src'

type PinnedResultsListProps = {
  pinnedResults: SearchResult[]
  setPinnedOrder: React.Dispatch<React.SetStateAction<SearchResult[]>>
  onResultRemoved: (result: SearchResult) => void
}

export const PinnedResultsList = ({
  pinnedResults,
  setPinnedOrder,
  onResultRemoved,
}: PinnedResultsListProps) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={pinnedResults} strategy={verticalListSortingStrategy}>
        {pinnedResults.map((item) => (
          <PinnedResult
            key={item.id}
            {...item}
            onRemove={() => {
              const newItems = pinnedResults.filter((i) => i.id !== item.id)
              setPinnedOrder(newItems)
              onResultRemoved(item)
            }}
          />
        ))}
      </SortableContext>
    </DndContext>
  )

  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event

    if (over && active.id !== over.id) {
      setPinnedOrder((items) => {
        const oldIndex = items.findIndex((i) => i.id === active.id)
        const newIndex = items.findIndex((i) => i.id === over.id)

        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }
}
